import axiosInstance from '@/api/axiosInstance';

export const getBrands = async () => {
  const response = await axiosInstance.get('/brands');
  return response.data;
}; 

export const getCards = async ({ 
  type, 
  sort, 
  direction,
  brandId,
  keyword,
  code,
  limit,
  setCode,
  boxType,
  cursor = null,
  searchByItem = false
}) => {
  const params = new URLSearchParams();
  
  if (type) {
    params.set('type', type);
  }
  
  params.set('sort', sort);
  params.set('direction', direction);
  
  if (brandId) {
    params.set('brandId', brandId);
  }
  
  if (keyword) {
    params.set('keyword', keyword);
  }
  
  if (code) {
    params.set('code', code);
  }
  
  if (limit) {
    params.set('limit', limit);
  }
  
  if (cursor) {
    params.set('cursor', cursor);
  }
  
  if (setCode) {
    params.set('setCode', setCode);
  }

  if (boxType) {
    params.set('boxType', boxType);
  }

  if (searchByItem) {
    params.set('searchByItem', searchByItem);
  }
  
  const response = await axiosInstance.get(`/products?${params.toString()}`);
  return response.data;
}; 

export const getCardFamily = async (id, includeStats = false) => {
  const params = new URLSearchParams();
  params.set('includeStats', includeStats);
  
  const response = await axiosInstance.get(`/products/${id}/family?${params.toString()}`);
  return response.data;
};

export const getRelatedCards = async (id) => {
  const response = await axiosInstance.get(`/products/${id}/related`);
  return response.data;
};

export const getFeaturedProducts = async () => {
  const response = await axiosInstance.get('/products/recommend-groups');
  return response.data;
};

export const getHeroBanners = async () => {
  const response = await axiosInstance.get('/home/hero-banners');
  return response.data;
};

export const getPsaListings = async (productId, { psa, limit = 40, cursor = null }) => {
  const params = new URLSearchParams();
  
  if (psa) {
    params.set('psa', psa);
  }
  
  params.set('limit', limit);
  
  if (cursor) {
    params.set('cursor', cursor);
  }
  
  const response = await axiosInstance.get(`/products/${productId}/listings/psa?${params.toString()}`);
  return response.data;
}; 